export default function NoteIcon(
  props: Pick<
    React.SVGProps<SVGSVGElement>,
    "className" | "fill" | "fillOpacity"
  >,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66797 5C1.66797 3.61929 2.78726 2.5 4.16797 2.5H15.8346C17.2153 2.5 18.3346 3.61929 18.3346 5V10C18.3346 10.2019 18.2614 10.3968 18.1285 10.5488L12.2951 17.2154C12.1369 17.3963 11.9083 17.5 11.668 17.5H4.16797C2.78726 17.5 1.66797 16.3807 1.66797 15V5ZM4.16797 4.16667C3.70773 4.16667 3.33464 4.53976 3.33464 5V15C3.33464 15.4602 3.70773 15.8333 4.16797 15.8333H10.8346V11.6667C10.8346 10.286 11.9539 9.16667 13.3346 9.16667H16.668V5C16.668 4.53976 16.2949 4.16667 15.8346 4.16667H4.16797ZM15.6648 10.8333H13.3346C12.8744 10.8333 12.5013 11.2064 12.5013 11.6667V14.4488L15.6648 10.8333ZM15.0013 6.66667C15.0013 7.1269 14.6282 7.5 14.168 7.5H5.83464C5.3744 7.5 5.0013 7.1269 5.0013 6.66667C5.0013 6.20643 5.3744 5.83333 5.83464 5.83333H14.168C14.6282 5.83333 15.0013 6.20643 15.0013 6.66667ZM8.7513 10.8333C9.21154 10.8333 9.58464 10.4602 9.58464 10C9.58464 9.53976 9.21154 9.16667 8.7513 9.16667H5.83464C5.3744 9.16667 5.0013 9.53976 5.0013 10C5.0013 10.4602 5.3744 10.8333 5.83464 10.8333H8.7513Z"
        fill={props.fill || "#0F1324"}
        fillOpacity={props.fillOpacity || "0.6"}
      />
    </svg>
  );
}
